import { ChangestatedialogComponent } from './features/dialogs/changestatedialog/changestatedialog.component';
import { LocalStorage } from './features/shared/localstorage.service';

import { AuthenticationService } from './features/shared/authentication.service';
import { Component, OnInit } from '@angular/core';
import {DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import { MatDialog, MatPaginator, MatSort } from '@angular/material';
import { CreatePackageDialogComponent } from '../app/features/package/create-package-dialog/create-package-dialog.component';
import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { UserService } from './features/shared/userService';
import { systemsettingsserviceService } from './features/shared/systemsettingsservice.service';
import { SystemSetting } from './features/shared/configuration.model';
import { element } from '@angular/core/src/render3';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  pageTitle = 'Quality Assurance Application';
   constructor(private _userService: UserService,
    private localStorage: LocalStorage,
    public auth: AuthenticationService,
    public local: LocalStorage,
    public dialog: MatDialog,
    public settingsservice: systemsettingsserviceService,
    private _router: Router,
    public userService: UserService) { }

   syssettings: SystemSetting[] = [];
   syssettingvalues: string[] = [];
   tokenExpiration: Date;
   hours: number;
   screen = false;

   ngOnInit() {

   }

   qualityQueueClick()
   {
     location.reload();

   }

   signOut() {
     this._userService.clearUser();

   }

   changeState() {

    this.syssettings = [];
    this.syssettingvalues = [];
    this.settingsservice.getSysytemSettings(this.auth.currentState).subscribe(res => {
      this.syssettings = res;
      this.syssettings.forEach(element => {
        if(element.Name === 'StateIdentifier') {
          this.screen = true;
          this.syssettingvalues = element.Value.split(',');
        if(this.syssettingvalues.length !== 0) {
          const changeStateDialogRef = this.dialog.open(ChangestatedialogComponent, {
            width: '500px',
            data: { syssettingvalues: this.syssettingvalues }
          });
          changeStateDialogRef.afterClosed().subscribe(result => {
            if (result)
            {

              this.userService.getUser(this.auth.username, this.auth.password, result).then(user => {
                changeStateDialogRef.close();
                this.screen = true;
                if (user.isAuthenticated) {
                    this.tokenExpiration = new Date();
                    this.hours = this.tokenExpiration.getHours();
                    this.tokenExpiration.setHours(this.hours + 8);
                    this.localStorage.setItem('userName', user.userName);
                    this.localStorage.setItem('passWord', user.passWord);
                    this.localStorage.setItem('token', user.token);
                    this.localStorage.setItem('role', user.role);
                    this.localStorage.setItem('isAuthenticated', 'true');
                    this.localStorage.setItem('tokenExpires', this.tokenExpiration.toString());
                    this.localStorage.setItem('currentState',result);
                    this._router.navigate(['/home']);
                    this.screen = false;
                } else {
                    this.screen = false;
                }
              });
            }
            this.screen = false;
          });
        }
      }
      });
    });

  }
}

